/* eslint-disable */
// import data_icon from "assets/desktop/images/deposit/data_icon.png";
//
import atm01 from "assets/desktop/images/deposit/example/example_atm01.png";
import atm02 from "assets/desktop/images/deposit/example/example_atm02.png";
import counterBank01 from "assets/desktop/images/deposit/example/example_counterBank01.png";
import counterBank02 from "assets/desktop/images/deposit/example/example_counterBank02.png";
//
import EBankCard01 from "assets/desktop/images/deposit/example/example_e-bankcard01.png";
import EBankCard02 from "assets/desktop/images/deposit/example/example_e-bankcard02.png";
import EBankCard03 from "assets/desktop/images/deposit/example/example_e-bankcard03.jpeg";
import EBankCard04 from "assets/desktop/images/deposit/example/example_e-bankcard04.jpeg";
import EBankCard05 from "assets/desktop/images/deposit/example/example_e-bankcard05.jpeg";
import EBankCard06 from "assets/desktop/images/deposit/example/example_e-bankcard06.jpeg";
import EBankCard07 from "assets/desktop/images/deposit/example/example_e-bankcard07.jpeg";
import EBankCard08 from "assets/desktop/images/deposit/example/example_e-bankcard08.jpeg";
import EBankCard09 from "assets/desktop/images/deposit/example/example_e-bankcard09.jpeg";
// //
import MomoQr01 from "assets/desktop/images/deposit/example/example_momoqr01.png";
import MomoQr02 from "assets/desktop/images/deposit/example/example_momoqr02.png";
import MomoQr03 from "assets/desktop/images/deposit/example/example_momoqr03.jpeg";
import MomoQr04 from "assets/desktop/images/deposit/example/example_momoqr04.jpeg";
// //
import ExampleOnline01 from "assets/desktop/images/deposit/example/example_onlineBank01.png";
import ExampleOnline02 from "assets/desktop/images/deposit/example/example_onlineBank02.png";
// //
import ExampleQrPayment01 from "assets/desktop/images/deposit/example/example_qrpayment01.png";
import ExampleQrPayment02 from "assets/desktop/images/deposit/example/example_qrpayment02.jpg";
import ExampleQrPayment04 from "assets/desktop/images/deposit/example/example_qrpayment04.jpeg";
import ExampleQrPayment05 from "assets/desktop/images/deposit/example/example_qrpayment05.jpeg";
// //
import ViettelMoney01 from "assets/desktop/images/deposit/example/example_viettelMoney01.png";
import ViettelMoney02 from "assets/desktop/images/deposit/example/example_viettelMoney02.jpg";
import ViettelMoney03 from "assets/desktop/images/deposit/example/example_viettelMoney03.jpeg";
import ViettelMoney04 from "assets/desktop/images/deposit/example/example_viettelMoney04.jpeg";
import ZaloQr01 from "assets/desktop/images/deposit/example/example_zaloqr01.png";
import ZaloQr02 from "assets/desktop/images/deposit/example/example_zaloqr02.png";
import ZaloQr03 from "assets/desktop/images/deposit/example/example_zaloqr03.jpeg";
import ZaloQr04 from "assets/desktop/images/deposit/example/example_zaloqr04.jpeg";
import AtmTransferImg from "assets/desktop/images/deposit/icon_AtmTransfer.png";
import GotoBank from "assets/desktop/images/deposit/icon_goToBank.png";
// //
import USDTQr01 from "assets/desktop/images/deposit/example/example_usdtqr01.png";
import USDTQr02 from "assets/desktop/images/deposit/example/example_usdtqr02.png";
import icon_momoPay from "assets/desktop/images/deposit/icon_momoPay.svg";
import icon_viettelpay from "assets/desktop/images/deposit/icon_viettelpay.png";
import icon_webBank_1 from "assets/desktop/images/deposit/icon_webBank_1.png";
import icon_zaloPay from "assets/desktop/images/deposit/icon_zaloPay.svg";
import img_ThirdPart from "assets/desktop/images/deposit/img_ThirdPart.png";
import icon_usdt from "assets/desktop/images/deposit/usdt.png";
import { DepositMethod } from "enums/deposit";
import React, { CSSProperties } from "react";

export interface DepositExample {
  texts: string[] | React.ReactNode[];
  content: React.ReactNode;
}

export interface DepositPaymentOption {
  id: DepositMethod;
  name: React.ReactNode;
  title?: string | React.ReactNode;
  image: string;
  minDeposit: number;
  maxDeposit: number;
  imageStyle?: CSSProperties;
  examples?: DepositExample[];
  isStepMode?: boolean;
  isLanguage?: boolean;
  isHide?: boolean;
}

export const DEPOSIT_PAYMENT_OPTIONS: DepositPaymentOption[] = [
  {
    id: DepositMethod.EBanking,
    name: (
      "手機銀行"
    ),
    title: "E-banking",
    image: "/desktop/deposit/payment_online.png",
    minDeposit: 100,
    maxDeposit: 50000,
    isLanguage: true,
    imageStyle: { width: "85%" },
    examples: [
      {
        texts: [
          "選擇方法",
          "選擇銀行",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleOnline01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇存款銀行",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleOnline02}
            alt=""
          />
        ),
      },
      // {
      //   texts: [
      //     <Translation ns={["payment"]}>
      //       {(t) => (
      //         <>{t("deposit.example.redirectToTheBank", { ns: "payment" })}</>
      //       )}
      //     </Translation>,
      //   ],
      //   content: <img style={{objectFit:"contain",width:"100%",maxHeight:"65vh"}} src={ExampleOnline03} alt="" />,
      // },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.ATM,
    name: (
      "ATM轉帳"
    ),
    image: AtmTransferImg,
    minDeposit: 100,
    maxDeposit: 50000,
    imageStyle: { width: "94px" },
    title: (
      "ATM轉帳流程"
    ),
    examples: [
      {
        texts: [
          "選擇銀行",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={atm01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇存款銀行",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={atm02}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.Online,
    name: (
      "電子銀行"
    ),
    title: "EbankCard",
    image: icon_webBank_1,
    minDeposit: 100,
    maxDeposit: 50000,
    imageStyle: { width: "75px" },
    examples: [
      {
        texts: [
          "選擇系統外快速轉帳",
          "選擇銀行",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "複製卡號",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard02}
            alt=""
          />
        ),
      },
      {
        texts: [
          "輸入使用者名",
          "輸入密碼",
          "輸入驗證碼",
          "按登入",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard03}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇 VCB 外 24/7 快速轉帳",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard04}
            alt=""
          />
        ),
      },
      {
        texts: [
          "透過卡片選擇 NAPAS247 快速轉帳",
          "點擊卡號轉帳",
          "輸入收款人卡號",
          "輸入金額",
          "按繼續",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard05}
            alt=""
          />
        ),
      },
      {
        texts: [
          "確認轉帳資訊正確",
          "輸入驗證碼",
          "按確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard06}
            alt=""
          />
        ),
      },
      {
        texts: [
          "輸入 OTP 碼",
          "按驗證",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard07}
            alt=""
          />
        ),
      },
      {
        texts: [
          "交易成功",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard08}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇銀行號碼，輸入儲值點數，然後按確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={EBankCard09}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.AtTheCounter,
    name: (
      "櫃檯服務"
    ),
    title: (
      "臨櫃轉帳流程"
    ),
    image: GotoBank,
    minDeposit: 100,
    maxDeposit: 50000,
    imageStyle: { width: "85%" },
    examples: [
      {
        texts: [
          "選擇方法",
          "選擇銀行",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={counterBank01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇存款銀行",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={counterBank02}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
    isHide: true,
  },
  {
    id: DepositMethod.QRPay,
    name: "QRcode",
    title: "QRpay",
    image: img_ThirdPart,
    minDeposit: 100,
    maxDeposit: 50000,
    imageStyle: { width: "94px" },
    examples: [
      {
        texts: [
          "選擇方法",
          "選擇銀行",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleQrPayment01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇存款銀行",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleQrPayment02}
            alt=""
          />
        ),
      },
      // {
      //   texts: [
      //     <Translation ns={["payment"]}>
      //       {(t) => (
      //         <>{t("deposit.example.displayQrCode", { ns: "payment" })}</>
      //       )}
      //     </Translation>,
      //   ],
      //   content: <img style={{objectFit:"contain",width:"100%",maxHeight:"65vh"}} src={ExampleQrPayment03} alt="" />,
      // },
      {
        texts: [
          "在銀行的手機應用程式上，選擇QR服務",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleQrPayment04}
            alt=""
          />
        ),
      },
      {
        texts: [
          "然後，掃描顯示的QR碼並進行支付",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ExampleQrPayment05}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.Momo,
    name: "MoMo",
    title: (
      "Momo掃碼"
    ),
    image: icon_momoPay,
    minDeposit: 100,
    maxDeposit: 10000,
    imageStyle: { width: "80px" },
    examples: [
      {
        texts: [
          "選擇方法",
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={MomoQr01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "顯示QR碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={MomoQr02}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇掃碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={MomoQr03}
            alt=""
          />
        ),
      },
      {
        texts: [
          "然後，掃描顯示的QR碼並進行支付",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={MomoQr04}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.ZaloPay,
    name: "ZaloPay",
    title: (
      "ZaloPay掃碼"
    ),
    image: icon_zaloPay,
    minDeposit: 100,
    maxDeposit: 10000,
    imageStyle: { width: "80px" },
    isStepMode: true,
    examples: [
      {
        texts: [
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ZaloQr01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "顯示QR碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ZaloQr02}
            alt=""
          />
        ),
      },
      {
        texts: [
          "選擇掃碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ZaloQr03}
            alt=""
          />
        ),
      },
      {
        texts: [
          "然後，掃描顯示的QR碼並進行支付",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ZaloQr04}
            alt=""
          />
        ),
      },
    ],
  },

  // {
  //   id: DepositMethod.Crypto,
  //   name: "Tiền mã hoá",
  //   image: data_icon,
  //   minDeposit: 200,
  //   maxDeposit: 20000,
  //   imageStyle: { width: "94px" },
  // },
  {
    id: DepositMethod.ViettelPay,
    name: "Viettel Money",
    title: "Viettel money",
    image: icon_viettelpay,
    minDeposit: 100,
    maxDeposit: 10000,
    imageStyle: { width: "80%" },
    examples: [
      {
        texts: [
          "選擇優惠",
          "輸入存款點數",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ViettelMoney01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "顯示QR碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ViettelMoney02}
            alt=""
          />
        ),
      },
      {
        texts: [
          "在 Viettel Money 應用程式上，選擇掃碼。",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ViettelMoney03}
            alt=""
          />
        ),
      },
      {
        texts: [
          "然後，掃描顯示的QR碼並進行支付",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={ViettelMoney04}
            alt=""
          />
        ),
      },
    ],
    isStepMode: true,
  },
  {
    id: DepositMethod.USDT,
    name: "USDT",
    title: (
      "TWD"
    ),
    image: icon_usdt,
    minDeposit: 100,
    maxDeposit: 10000,
    imageStyle: { width: "80px" },
    isStepMode: true,
    examples: [
      {
        texts: [
          "選擇優惠",
          "輸入錢包地址",
          "輸入TWD金額",
          "點擊確認",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={USDTQr01}
            alt=""
          />
        ),
      },
      {
        texts: [
          "顯示QR碼",
        ],
        content: (
          <img
            style={{ objectFit: "contain", width: "100%", maxHeight: "65vh" }}
            src={USDTQr02}
            alt=""
          />
        ),
      },
    ],
  },
];
